export class InviteListConfig {
  type: string;
  limit?: number;
  offset?: number;
  targetModel?: string;
  sender?: string;
  recipient?: string;
  status?: string;
}
